import { useQuery } from "@tanstack/react-query";
import { AgentsQueryKeys } from "./agentQueryKeys";
import { getAgent, GetAgentQueryParams } from "@/api/agents/getAgent";

export const useAgent = (
  filters: GetAgentQueryParams,
  options: { enabled?: boolean } = {}
) => {
  return useQuery({
    queryKey: [AgentsQueryKeys.Agent, filters],
    enabled: options.enabled ?? true,
    queryFn: ({ signal }) => {
      const params = { id: filters.id };
      return getAgent({ signal, params });
    },
  });
};
